import { isEmpty } from 'lodash';
import { notifySet, resetRedux, customerReset } from '../redux/actions';
import { store } from '../redux/store';
import { clearAuthToken } from '../utils/firebase';

export const userLogout = async () => {
  setTimeout(() => {
    clearAuthToken();
    sessionStorage.clear();
    store.dispatch(resetRedux());
    store.dispatch(customerReset());
    store.dispatch(notifySet({ type: 'success', message: 'You have successfully signed out.' }));
  }, 100);
};

export const checkPermission = async (user, navigate) => {
  setTimeout(() => {
    if (isEmpty(user.id)) {
      navigate('/login', {
        replace: true
      });
    }
  }, 2000);
};

export const getImgDimension = (file) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  });

export const getBrowserHelpLink = () => {
  const ua = navigator.userAgent;

  if (/Chrome/.test(ua) && !/Edg/.test(ua)) {
    return 'https://support.google.com/chrome/answer/2693767'; // Chrome
  }
  if (/Safari/.test(ua) && !/Chrome/.test(ua)) {
    return 'https://support.apple.com/en-in/HT209175'; // Safari
  }
  if (/Firefox/.test(ua)) {
    return 'https://support.mozilla.org/en-US/kb/how-manage-camera-and-microphone-permissions'; // Firefox
  }
  if (/Edg/.test(ua)) {
    return 'https://support.microsoft.com/en-us/microsoft-edge/camera-microphone-and-location-permissions-in-microsoft-edge-5cfc09d0-29bc-4a36-ad12-14c8c0336ce0'; // Edge
  }
  return 'https://www.whatismybrowser.com/guides/how-to-enable-camera'; // fallback
};

// eslint-disable-next-line no-extend-native
Object.defineProperty(String.prototype, 'capitalize', {
  value() {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false
});

export const filterByValue = (array, string) =>
  array.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
